import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TRegisterUser, TGoogleSignInBody } from "./types";

export const postGoogleSignIn = async (payload: TGoogleSignInBody) => {
  const { data } = await client.post<TGoogleSignInBody, TRegisterUser>(
    Endpoints.postGoogleSignIn,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
